module.exports = __webpack_public_path__ + "img/crm_case8.ac63d2ac.png";